<template>
    <div>
        <a-modal :title="title" v-model="visible" @ok="handleOk" class="cancel-out-model">
            <div class="cancel-out-image">
                <img src="@/assets/image/tishi.png" alt="" class="image">
                <div class="hint-text">
                    <span class="font-size-16">您确认取消退出？</span>
                    <span class="font-size-14" style="color: #FF0000;">确认后，当前页的信息不会保存</span>
                </div>
            </div>
        </a-modal>
        <a-modal :title="title" v-model="visible1" @ok="handleOk1" @cancel="cancel1" :cancelText="cancelText" :okText="okText" class="cancel-out-model">
            <div class="cancel-out-image">
                <img src="@/assets/image/tishi.png" alt="" class="image">
                <div class="hint-text">
                    <span class="font-size-16">您确认取消退出？</span>
                    <span class="font-size-14" style="color: #FF0000; font-size:14px">确认后，当前页的信息不会保存</span>
                </div>
            </div>
        </a-modal>
    </div>
</template>

<script>
export default {
  name: 'cancelOut',
  data () {
    return {
      title: '提示',
      visible: false,
      visible1:false,
      cancelText:'直接废弃',
      okText:'存为草稿'
    }
  },
  methods: {
    show () {
      this.visible = true
    },
      show1(){
        this.visible1 = true
      },
    cancel () {
        this.visible = false
        // this.$store.state.closePath = this.$route.fullPath
    },
    handleOk () {
       this.visible = false
        this.$store.state.closePath = this.$route.fullPath
    },
      handleOk1(){
          this.visible = false
          this.$emit('cancelsaveDraft')
      },
      cancel1(){
          this.visible1 = false
          this.$store.state.closePath = this.$route.fullPath
      }
  }
}
</script>
<style lang="scss">
.cancel-out-model {
  width: 560px !important;
  .ant-modal-content {
    height: 280px;
    border-radius: 10px;
    .ant-modal-header {
      border-radius: 10px 10px 0 0;
    }
    .ant-modal-body {
      height: 110px;
      display: flex;
      //   align-items: center;
      justify-content: center;
      padding: 30px 0 0 0;
    }
      .ant-modal-footer{
          padding-bottom: 30px;
      }
    .ant-btn {
      width: 140px;
      border-radius: 6px !important;
    }

    .cancel-out-image {
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      .image {
        width: 50px;
        height: 50px;
        margin-right: 16px;
      }
      .hint-text {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        line-height: 1.8;
      }
    }
  }
}
</style>
